<template>
    <div class="single-swop bg-light">
        <div v-if="data">
            <div class="bg-white h-32 border-b border-solid border-gray-300 flex items-center">
                <div class="container p-8 mx-auto">
                    <div class="md:flex md:items-center md:justify-between">
                        <div class="flex-1 min-w-0">
                            <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                                {{ data.serial }}
                            </h2>
                            <div class="flex mt-4 text-gray-500">
                                <div class="mr-6">
                                    <i class="fas fa-box text-sm mr-1" />
                                    {{ data.container.name }}
                                </div>
                                <div class="mr-6">
                                    <i class="fas fa-clock text-sm mr-1" />
                                    {{ timeFromNow(data.created_at) }}
                                </div>
                                <div class="mr-6">
                                    <i class="fas fa-user text-sm mr-1" />
                                    {{ data.worker.name }}
                                </div>
                                <div>
                                    <i class="fas fa-cog text-sm mr-1" />
                                    {{ data.parts.length }}
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 flex md:mt-0 md:ml-4">
                            <span class="hidden sm:block ml-3 shadow-sm rounded-md">
                                <button type="button" @click="showTestAlert = true" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out">
                                    Udfør {{ data.tests.length + 1 }}. test
                                </button>
                                <custom-alert
                                    v-if="showTestAlert"
                                    heading="Er du sikker?"
                                    :description="'Du er ved at udføre <b>test #' + (data.tests.length + 1) + '</b>'"
                                    acceptText="Ja"
                                    cancelText="Annullér"
                                    @cancel="showTestAlert = false"
                                    @accept="test()"
                                />
                            </span>
                            <span class="ml-3 shadow-sm rounded-md">
                                <button @click="complete()" type="button" class="bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white">
                                    <div class="flex items-center">
                                        Afslut SWOP
                                    </div>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content overflow-y-auto" style="height:calc(100vh - 12rem);-webkit-overflow-scrolling:touch;">
                <div class="container mx-auto p-8">
                    <div class="flex flex-wrap -mx-4 -mb-8" v-if="data.available_parts.length > 0">
                        <div class="h-32 w-1/3 px-4 mb-8 outline-none focus:outline-none hover:outline-none" v-for="part in data.available_parts" :key="part.id">
                            <div @click="addPart(part)" :class="{'selected': part.count > 0}" class="part-card cursor-pointer relative h-full flex items-center overflow-hidden bg-white shadow rounded py-4 px-6">
                                <div>
                                    <div class="text-xl font-semibold mb-2 text-gray-900 leading-tight">
                                        {{ part.name }}
                                    </div>
                                    <div class="text-gray-500">
                                        <span v-if="part.count > 0">
                                            <span class="text-main">{{ part.count }} stk</span> |
                                        </span>
                                        {{ part.number }}
                                    </div>
                                    <div v-if="part.count > 0" @click="removePart(part)" class="remove-part-btn absolute bottom-0 right-0 h-10 w-16 text-sm text-white flex items-center justify-center">
                                        Fjern
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .part-card {

        &.selected {
            /* border-top-left-radius: 0px !important;
            border-bottom-left-radius: 0px !important;
            border-left: 3px solid $color--main; */
            background: $color--main;
            color: #fff !important;
        }

        &.selected * {
            color: #fff !important;
        }
    }

</style>

<script>
import * as swopService from '@/services/swopService'
import moment from 'moment'

export default {
    data () {
        return {
            showTestAlert: false,
            data: null
        }
    },
    created () {
        this.getSwop()
    },
    methods: {
        getSwop () {
            swopService.find(this.$route.params.id, null, (response) => {
                this.data = response.data
                console.log(response.data)
            }, (err) => {
                // Handle error
                console.log(err)
            })
        },
        addPart (part) {
            if (!event.target.classList.contains('remove-part-btn')) {
                swopService.addPart(this.$route.params.id, part.id, null, (response) => {
                    console.log(response)
                    this.getSwop()
                })
            }
        },
        removePart (part) {
            swopService.removePart(this.$route.params.id, part.id, null, (response) => {
                console.log(response)
                this.getSwop()
            })
        },
        test () {
            swopService.test(this.$route.params.id, null, (response) => {
                console.log(response)
                this.getSwop()
                this.showTestAlert = false
            })
        },
        complete () {
            alert('Complete SWOP now')
        },
        timeFromNow (date) {
            let output = moment(date).fromNow()
            return output
        }
    }
}
</script>



// WEBPACK FOOTER //
// singleSwop.vue?08eabc11